<template>
  <v-row class="pa-2" no-gutters>
    <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
    </v-col>

    <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

    <v-col
      class="pa-2 sticky-md"
      cols="12"
      md="4"
      style="top: 110px; height: fit-content"
    >
      <v-tabs-items
        v-model="qrShow"
        class="overflow-visible mb-4 mb-md-0"
        touchless
      >
        <v-tab-item>
          <qr-maker :loading="loading" :svg="svgMade" />
          <v-btn class="btn-download" @click="showDialog = true">
            <v-icon>mdi-progress-download</v-icon>
            {{ $t("download_qr") }}          </v-btn>
        </v-tab-item>

        <v-tab-item>
          <view-shop v-model="cardTexts" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-col class="pa-2 px-0" cols="12" md="8">
      <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
        <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
          <div class="row justify-center">
            <div class="col-md-12">
              <p>وارد کردن اطلاعات صفحه کاری</p>
            </div>
            <div class="col-md-6 mt-0 pt-0">
              <v-text-field
                v-model="cardTexts.visitName"
                :disabled="e6 > 2"
                append-icon="mdi-pen"
                class="mt-0 pt-0"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="نام صفحه کاری شما"
                outlined
              />
            </div>
          </div>
        </v-stepper-step>
        <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
          <v-btn
            :disabled="e6 > 2"
            class="mb-4"
            color="third"
            outlined
            @click="clearDefaults"
          >
            <v-icon class="me-2">mdi-delete</v-icon>
            حذف اطلاعات پیشفرض
          </v-btn>

          <list-expansion
            v-model="cardTexts"
            :components="specialInfo"
            :data="cardTexts"
            flat
          />

          <div class="col-md-12">
            <next-btn
              :loading="loading"
              style="background: #1b8d39"
              @click="markQr"
              v-text="'بعدی'"
            />
          </div>
        </v-stepper-content>
      </v-stepper>
    </v-col>

    <custom-popup
      v-model="showDialog"
      :cons="cons"
      hide-confirm
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <template v-slot:helpinfo>
        <help-info
          :element-name="`${serviceName}-${componentName}-download-Qr`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="دانلود کیوآر"
        />
      </template>
      <v-card class="px-5">
        <download-file
          v-if="showDialog"
          :data="{ theme: '', data: cardTexts }"
          :svg="svgMade"
          :visit-name="cardTexts.visitName"
        />
      </v-card>
    </custom-popup>
  </v-row>
</template>

<script>
import { Bus, debounce, RobotAxios } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop";
import Counter from "@/view/components/Counter";
import Personnel from "@/view/components/Personnel";
import WorkSheet from "@/view/components/WorkSheet";
import Product from "@/view/components/Product/index";

export default {
  name: "createShop",

  components: {
    Counter,
    ViewShop,
    Personnel,
    WorkSheet,
    DownloadFile,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
  },

  data() {
    return {
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود بنر",
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "Service",
          value: "",
          title: "خدمات",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "سوالات متداول",
          subtitle: "",
          icon: "help",
          model: "faq",
        },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        {
          name: "Product",
          value: "",
          title: "ایجاد محصول",
          subtitle: "",
          icon: "sign-yield",
          model: "Product",
        },
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "گالری عکس",
          subtitle: "",
          icon: "image-outline",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
        //     {
        //   name: "consultationNew",
        //   value: "",
        //   title: "فرم درخواست",
        //   subtitle: "",
        //   icon: "list-box-outline",
        //   model: "consultationNew",
        // },
        //   {
        //   name: "FeedBack",
        //   value: "",
        //   title: "بازخورد",
        //   subtitle: "",
        //   icon: "reply-outline",
        //   model: "FeedBack",
        // },
        {
          name: "ServiceSection",
          value: "",
          title: "ایجاد بخش",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "موفقیت های بدست آمده",
          subtitle: "",
          icon: "bullseye-arrow",
          model: "CounterService",
        },
        {
          name: "Counter",
          value: "",
          title: "شمارنده معکوس",
          subtitle: "",
          icon: "timer-sand",
          model: "Counter",
        },
        {
          name: "Personnel",
          value: "",
          title: "اعضای تیم",
          subtitle: "",
          icon: "account-multiple-outline",
          model: "Personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "تایم کاری",
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
      ],
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
       cardTexts: {
        pdf: [
          {
            name: "گالری پروپزال‌های کیوآرلند",
            images: [
              {
                title: "پروپزال معرفی محصول",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description:
                  "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
                selected: true,
              },
              {
                title: "پروپزال کارت ویزیت الکترونیکی",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description:
                  "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
                selected: true,
              },
            ],
          },
        ],
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "6",
                  title: "سامانه بزرگ کیوآر لند",
                  url: "",
                  description: "",
                  link: "qrland.ir",
                  id: 10278,
                },
                {
                  name: "2",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 10279,
                },
              ],
            },
          ],
        },
        Product: {
          title: "محصولات",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        blog: [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: "",
            icon: "",
          },
        ],
        service: [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ],
        video_gallery: [
          {
            name: "تبلیغاتی",
            images: [
              {
                title: "تریلر کیوآر داینامیک",
                url: "https://www.aparat.com/video/video/embed/videohash/DZUuA/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "کارت ویزیت الکترونیکی",
                url: "https://www.aparat.com/video/video/embed/videohash/NnK26/vt/frame",
                description: "",
                link: "",
              },
            ],
          },
          {
            name: "آموزشی",
            images: [
              {
                title: "ثبت نام در سامانه کیوآر لند",
                url: "https://www.aparat.com/video/video/embed/videohash/UY4KN/vt/frame",
                description: "",
                link: "core.terminalads.com",
              },
              {
                title: "ساخت کارت ویزیت الکترونیکی",
                url: "https://www.aparat.com/video/video/embed/videohash/qoD2r/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "لیست کیوآرهای من",
                url: "https://www.aparat.com/video/video/embed/videohash/xq9rz/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "آمار بازدید کیوآرکدهای داینامیک",
                url: "https://www.aparat.com/video/video/embed/videohash/AyczW/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "آپلودسنتر کیوآرلند",
                url: "https://www.aparat.com/video/video/embed/videohash/FJZ1S/vt/frame",
                description: "",
                link: "",
              },
            ],
          },
        ],
        gallery: [
          {
            name: "کیوآر داینامیک",
            images: [
              {
                name: "18",
                title: "اسکن ساده و آسان",
                url: "",
                description: "",
                link: "",
                id: 12301,
              },
              {
                name: "8",
                title: "یک دنیا اطلاعات را در یک کیوآر جای دهید",
                url: "",
                description: "",
                link: "",
                id: 12302,
              },
              {
                name: "10",
                title: "قابلیت رمز گذاری",
                url: "",
                description: "",
                link: "",
                id: 12304,
              },
              {
                name: "11",
                title: "امکان پرداخت و تسویه",
                url: "",
                description: "",
                link: "",
                id: 12305,
              },
            ],
          },
          {
            name: "کیوآر کد",
            images: [
              {
                name: "12",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12306,
              },
              {
                name: "2",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12311,
              },
              {
                name: "6",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12315,
              },
            ],
          },
        ],
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        consultation: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
            name: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام",
            },
            surname: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام خانوادگی",
            },
            phone: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "شماره موبایل",
            },
            mail: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "ایمیل",
            },
            address: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "آدرس",
            },
            nationalId: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "کدملی",
              verify: "correct",
            },
            location: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "لوکیشن",
            },
            custom: {
              is_active: false,
              type: "optional",
              value: "",
              format: "select",
              extra: {
                label: "",
                options: [],
              },
            },
            description: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "توضیحات",
            },
          },
        },
        consultationNew: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        },
        Personnel: {
          title: "تیم ما",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        WorkSheet: {
          items: {
            saturday: {
              name: "شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "17:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            sunday: {
              name: "یکشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "17:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            monday: {
              name: "دوشنبه",
              shift: [{}, {}],
            },
            tuesday: {
              name: "سه‌شنبه",
              shift: [{}, {}],
            },
            wednesday: {
              name: "چهارشنبه",
              shift: [{}, {}],
            },
            thursday: {
              name: "پنجشنبه",
              shift: [{}, {}],
            },
            friday: {
              name: "جمعه",
              shift: [{}, {}],
            },
          },
        },
        Counter: {
          title: "حالا در آینده زندگی کنید...",
          description: "خبرهای خوبی برایتان داریم.",
          until: "2023-08-23 00:00:00",
          type: "countdown_2",
        },
        visitName: "صفحه کاری کیوآر لند",
        organizationName: "سامانه بزرگ کیوآر لند",
        subOrgan: "مدیریت همزمان ۴۰ روش تبلیغاتی!",
        userName: "خانم خوانساری",
        workField: "پشتیبانی",
        phoneNumber: [
          {
            number: "09999903535",
          },
          {
            number: "02191017077",
          },
          {
            number: "90007425",
          },
        ],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان\nبن بست خندان ، پلاک 6 ، واحد 3",
        city: "",
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: {
          address: [
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: "اینستاگرام",
              text: "نام کاربری خود را وارد نمایید",
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: "واتساپ",
              text: "+989123456789",
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
          aparat: [
            {
              hint: "نام کانال آپارات خود را وارد نمایید",
              label: "آپارات",
              url: "qrland",
              prefix: "@",
              pattern: "www.aparat.com/",
              img: "/media/socialIcon/40icon/pr/aparat.svg",
              socialText: "",
              svg: "svgAparat",
            },
          ],
        },
        aboutUs:
          "کیوآر چیست؟\nیک نوع بارکد دو بعدی است که می تواند با استفاده از گوشی های هوشمند و دستگاه های اختصاصی کد خوان، خوانده  می شود.\nکیوآرها به طور مستقیم به متن، ایمیل، وب سایت، شماره تلفن و... متصل می شود. \n\nکیوآر داینامیک چیست؟\nکدهای کیو آر داینامیک متصل به سرورهای اختصاصی پیشرفته و هوشمند هستند.\nاینگونه کلیه داده ها و دیتاها را به صورت اتوماتیک در فضای ابری امن و کاملا حفاظت شده، دسته بندی و فشرده سازی  میکند. همین امر باعث رفع کلیه ضعف های کیوآر های استاتیک  می شود.\nکیوآر داینامیک علاوه بر دارا بودن جدیدترین تکنولوژی های دیجیتالی و هوشمند، کاملا انعطاف پذیر است. و می توان با کیوآر داینامیک تمامی شکاف های موجود در یک مجموعه یا سازمان را برطرف نمود.\n برای حفظ محیط زیست، نیاز است استفاده از کاغذ را کاهش داد. ",
        copyright: "تمامی حقوق این سایت متعلق به ترمینال تبلیغات می باشد.",
        center: [51.44663997885132, 35.74305387731438],
        coordinates: [51.446682645747444, 35.743053507096036],
        address:
          "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #007376FF, #08004AFF)",
            text: "#fff",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "#FFFFFF",
            text: "#333333",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        CounterService: {
          title: "دستاوردها",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              type: "percent",
              counter: "92",
              name: "کاربران راضی",
              icon: "mdi-account",
              link: "",
            },
            {
              type: "number",
              counter: "180",
              name: "صنف به ما اعتماد کرده اند",
              icon: "mdi-google-classroom",
              link: "",
            },
            {
              type: "number",
              counter: "6",
              name: "خدمت ارائه شده",
              icon: "mdi-qrcode-scan",
              link: "",
            },
            {
              type: "number",
              counter: "64",
              name: "خدمت جدید در راه",
              icon: "mdi-qrcode-plus",
              link: "",
            },
          ],
        },
        ServiceSection: {
          title: "به روز باشید...",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #37A9ADFF, #423890FF)",
            text: "#fff",
          },
          items: [
            {
              section: {
                title: "ثبت نام",
                text: "شما به سرزمین هوشمند دیجیتالی کیوآر لند دعوت شده اید.",
                button: {
                  title: "ثبت نام رایگان",
                  icon: "mdi-ballot-recount",
                  background:
                    "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
                  color: "#ffffffff",
                  link: "core.terminalads.com",
                  target: "",
                },
                text_position: "left",
                object: {
                  type: "image",
                  url: "",
                },
              },
            },
          ],
        },
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description:
            "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئو های زیر را مشاهده فرمایید.",
          sectionColor: {
            backGround: "linear-gradient(to right , #25AD96FF, #2039A4FF)",
            text: "#fff",
          },
        },
        Service: {
          title: "خدمات کیوآر لند",
          slider: false,
          description:
            "دیگه وقتشه تکنولوژی دیجیتال را به کسب  وکارتان اضافه کنید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "#fff",
          },
          type: "text",
          items: [
            {
              question: "چقدر از خدمات کیوآرلند راضی بوده اید؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: true,
            },
            {
              question:
                "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
              type: "star",
              value: null,
              description: true,
              forceDesc: true,
            },
          ],
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [
            {
              question: "1. چطوری می تونم سفارش خودم رو ثبت کنم ؟",
              answer: "کافیست محصولات مورد نظر خود را به سبد خرید اضافه کنید.",
            },
            {
              question: "2. چگونه می توانم در سایت ثبت نام کنم؟",
              answer:
                'کافیست بر روی دکمه "ورود" کلیک کنید و پس از وارد کردن شماره همراه، کد پیامک شده را نیز وارد کنید.',
            },
            {
              question:
                "3. پس از اینکه سفارشم رو ثبت کردم چقدر طول می کشه به دستم برسه؟",
              answer: "در سریع ترین زمان ممکن سفارش شما ارسال خواهد شد.",
            },
            {
              question: "4. هزینه ارسال سفارش چقدر هست؟",
              answer: "هزینه ارسال سفارش نسبت به آدرس شما متغییر خواهد بود.",
            },
            {
              question:
                "5. آیا می تونم بعد از ثبت سفارش، محصولمو تغییر بدم یا کنسل کنم ؟",
              answer: "خیر.\nامکان تغییر یا لغو وجود ندارد.",
            },
          ],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  mounted() {
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },

  watch: {
    qrDesign: {
      handler() {
        if (this.destinationUrl) {
          debounce(() => {
            this.preview(this.destinationUrl);
          }, 3000);
        }
      },
      deep: true,
    },
  },

  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "simpleBpage",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
        qr: obj,
        type: "simpleBpage",
        title: this.cardTexts.visitName,
      })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("صفحه کاری شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#link",
          link: link,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: this.qrDesign.MarkerCenter.different_markers_color
            ? "on"
            : undefined,
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : undefined,
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : undefined,
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : undefined,
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.svgMade = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setSettings() {
      const res = await this.$refs.qrManage.update();
      this.e6++;
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new FormData();
      data.append("type", "bShop");
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");

      data.append("qr[section]", "#link");
      data.append(
        "qr[backcolor]",
        !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor,
      );
      data.append(
        "qr[gradient_color]",
        !this.qrDesign.qrStyleColors?.gradient_color
          ? "#000000"
          : this.qrDesign.qrStyleColors?.gradient_color,
      );
      data.append(
        "qr[frontcolor]",
        !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor,
      );
      data.append(
        "qr[gradient]",
        this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
      );
      data.append("qr[pattern]", this.qrDesign.qrStyleColors.pattern);
      data.append("qr[marker_in]", this.qrDesign.MarkerCenter.eyePattern);
      data.append("qr[marker_in_color]", this.qrDesign.MarkerCenter.main);
      data.append("qr[markers_color]", "on");
      data.append("qr[marker]", this.qrDesign.QrMarkOut.markOutPattern);
      data.append(
        "qr[different_markers_color]",
        this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : undefined,
      );
      data.append("qr[marker_out_color]", this.qrDesign.QrMarkOut.main);
      data.append(
        "qr[marker_top_right_outline]",
        this.qrDesign.QrMarkOut.topRight,
      );
      data.append(
        "qr[marker_top_right_center]",
        this.qrDesign.MarkerCenter.topRight,
      );
      data.append(
        "qr[marker_bottom_left_outline]",
        this.qrDesign.QrMarkOut.bottomLeft,
      );
      data.append(
        "qr[marker_bottom_left_center]",
        this.qrDesign.MarkerCenter.bottomLeft,
      );
      data.append(
        "qr[custom_frame_color]",
        this.qrDesign.QrFrame?.different_markers_color ? "on" : undefined,
      );
      data.append("qr[outer_frame]", this.qrDesign.QrFrame.framePattern);
      data.append("qr[framecolor]", this.qrDesign.QrFrame.main);
      data.append("qr[framelabel]", this.qrDesign.QrFrame.text);
      data.append("qr[optionlogo]", this.qrDesign.LogoImg.logoImg);
      data.append(
        "qr[no_logo_bg]",
        this.qrDesign.LogoImg.noBg ? "on" : undefined,
      );
      data.append("qr[label_font]", "AbrilFatface.svg");
      data.append("qr[size]", "248");
      data.append("qr[level]", "H");
      data.append('qr["logo-size"]', this.qrDesign.LogoImg.logoSize);
      data.append('qr["label-text-size"]', "100");

      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          this.finish = final;
          this.$toast.success("کیوآر شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        pdf: undefined,
        banner: undefined,
        blog: undefined,
        service: undefined,
        video_gallery: undefined,
        gallery: undefined,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: null }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: null,
        email: null,
        fax: null,
        location: null,
        city: null,
        codePostal: null,
        province: null,
        country: null,
        website: null,
        socialMedia: {},
        aboutUs: null,
        copyright: null,
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: null,
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        PicSelector: {
          title: "گالری عکس",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            images: [],
          },
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        faqs: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
